<div class="header-title">
  <div class="container-desktop">
    <img class="title-image" src="../../../assets/profile-menu/BannerConversordepuntos.png" alt="">
  </div>
</div>

<div class="section spinner" style="min-height: 30vh;" *ngIf="ready <= 2">

<img [src]="assetUrl('assets/images/logo-borde-gris.svg')" class="brand-shell spinner">

</div>

<div *ngIf="ready > 2" class="errorLatam">
<div  *ngIf="errorLatam" style="text-align: center;">
  <h4>No se encuentra inscripto en Shell LATAM Pass</h4>
  <p>Debe asociarse al programa para utilizar millas. <a href="https://latampass.latam.com/es_ar/" target="_blank">https://latampass.latam.com/es_ar/</a></p>
</div>
</div>

<div *ngIf="ready > 2" class="errorLatam">
<div  *ngIf="errorConversor" style="text-align: center;">
  <h4>El conversor no se encuentra disponible en este momento</h4>
  <p>Vuelva a intentar en unos minutos</p>
</div>
</div>


<div class="section" *ngIf="ready > 2">
  <div class="conversor-info" *ngIf="!errorLatam && !errorConversor">
      <div class="text-container">
          <h4 class="headingMobile" style="font-size: 26px; margin-top: 20px;">Conversor de Puntos<br><br></h4>
          <h4>¿Sabés qué es el conversor de puntos?</h4>
          <p>Con el nuevo programa Shell Box, ahora podés cambiar tus Millas LATAM PASS por puntos.</p>
      </div>
      <div class="card-white" *ngFor="let item of programs">
          <div class="heading-card">
              <img class="latampass" *ngIf="item.loyaltyProgram == 'LatamPass'" [src]="assetUrl('assets/images/latampass-icon.png')" alt="">
              <img *ngIf="item.loyaltyProgram == 'ShellBox'" [src]="assetUrl('assets/images/logo-borde-gris.svg')" alt="">
              <h4>{{item?.loyaltyProgram}}</h4>
          </div>
          <div class="body-card">
              <p *ngIf="item.loyaltyProgram == 'LatamPass'"><span>{{item?.balance}}</span> millas disponibles totales</p>
              <p *ngIf="item.loyaltyProgram == 'ShellBox'"><span>{{item?.balance}}</span> puntos Shell Box disponibles totales</p>
          </div>
      </div>
  </div>
  <div class="conversor" *ngIf="!errorLatam && !errorConversor">
      <div class="card">
          <div class="card-50">
            <form [formGroup]='conversorForm'>
              <select (change)="handleCurrencyChange($event)" class="form-select" aria-label="Default select example">
                  <option value="millas" selected>Millas</option>
                  <option value="puntos">Puntos</option>
              </select>
              <input formControlName="inputValue" (input)="handleInputAmountChange($event)" [step]="step" placeholder="0" type="number">
            </form>
              <p *ngIf="selectedCurrency == 'millas'" class="remain-points">{{programs[1]?.availableBalance}} millas disponibles</p>
              <p *ngIf="selectedCurrency == 'puntos'" class="remain-points">{{programs[0]?.availableBalance}} puntos disponibles</p>
          </div>
          <img class="flecha1" [src]="assetUrl('assets/images/flecha.png')"/>
          <img class="flecha2" [src]="assetUrl('assets/images/flecha.png')"/>
          <div class="card-50">
              <p *ngIf="selectedCurrency == 'millas'">Puntos</p>
              <p *ngIf="selectedCurrency == 'puntos'">Millas</p>
              <p *ngIf="selectedCurrency == 'millas'" class="points">{{outputAmount}}</p>
              <p *ngIf="selectedCurrency == 'puntos'" class="points">{{outputAmount}}</p>
              <p *ngIf="selectedCurrency == 'millas'" class="remain-points">{{programs[0]?.availableBalance}} puntos disponibles</p>
              <p *ngIf="selectedCurrency == 'puntos'" class="remain-points">{{programs[1]?.availableBalance}} millas disponibles</p>
          </div>
          <p class="ratio">1 milla = {{types[0]?.ratio}} puntos. Sólo se podran ingresar valores múltiplos del ratio correspondiente</p>
      </div>
      <button (click)="conversionStep = 1" *ngIf="puedeConvertir()" class="convert-button">CONVERTIR AHORA</button>
  </div>
</div>

<div class="modal-main-container" *ngIf="conversionStep > 0">
  <div *ngIf="conversionStep == 1" class="modal-card">
      <button (click)="conversionStep = 0" class="btn-close"></button>
      <p class="modal-title">¡Estás a un paso de obtener tus puntos!</p>
      <div class="exchange-item">
          <p *ngIf="selectedCurrency == 'millas'">Millas</p>
          <p *ngIf="selectedCurrency == 'puntos'">Puntos Shell Box</p>
          <span class="red">-{{inputAmount}}</span>
      </div>
      <div class="exchange-item">
          <p *ngIf="selectedCurrency == 'millas'">Puntos Shell Box</p>
          <p *ngIf="selectedCurrency == 'puntos'">Millas</p>
          <span class="green">+{{outputAmount}}</span>
      </div>
      <div class="buttons-container">
          <p (click)="conversionStep = 0">Cancelar</p>
          <button (click)="handleConversion()">Confirmar</button>
      </div>
  </div>
  <div *ngIf="conversionStep == 2" class="modal-card">
      <p>Estamos procesando la conversión solicitada...</p>
  </div>
  <div *ngIf="conversionStep == 3" class="modal-card">
      <button (click)="conversionStep = 0" class="btn-close"></button>
      <img [src]="assetUrl('assets/images/green-tick.png')"/>
      <p style="margin: 5px 0 30px 0;" class="modal-title">¡Millas convertidas con éxito!</p>
      <div class="exchange-item">
          <p *ngIf="selectedCurrency == 'millas'">Millas</p>
          <p *ngIf="selectedCurrency == 'puntos'">Puntos Shell Box</p>
          <span class="red">-{{inputAmount}}</span>
      </div>
      <div class="exchange-item">
          <p *ngIf="selectedCurrency == 'millas'">Puntos Shell Box</p>
          <p *ngIf="selectedCurrency == 'puntos'">Millas</p>
          <span class="green">+{{outputAmount}}</span>
      </div>
      <div style="justify-content: center;" class="buttons-container">
          <button (click)="conversionStep = 0">Volver al conversor</button>
      </div>
  </div>
  <div *ngIf="conversionStep == 4" class="modal-card">
      <button (click)="conversionStep = 0" class="btn-close"></button>
      <img [src]="assetUrl('assets/images/error.png')"/>
      <p style="margin: 5px 0 30px 0;" class="modal-title">Lo sentimos, hubo un error en la conversion. Intentalo de nuevo mas tarde.</p>
      <div style="justify-content: center;" class="buttons-container">
          <button (click)="conversionStep = 0">Volver al conversor</button>
      </div>
  </div>
</div>
